{
  "layouts": {
    "auth": {
      "card": {
        "content": {
          "login": "Login",
          "signUp": "Cadastrar-se"
        }
      }
    }
  },
  "pages": {
    "integrations": {
      "title": "Integrações — Chaves de API",
      "description": "Gere e revogue chaves de API por empresa para o canal externo de tickets.",
      "loading": "Carregando chaves...",
      "empty": "Nenhuma chave de API gerada ainda.",
      "table": {
        "company": "Empresa",
        "name": "Nome",
        "key": "Chave",
        "lastUsed": "Último uso",
        "status": "Status",
        "actions": "Ações"
      },
      "status": {
        "active": "Ativa",
        "revoked": "Revogada"
      },
      "actions": {
        "generate": "Gerar chave",
        "cancel": "Cancelar",
        "done": "Concluir"
      },
      "generate": {
        "title": "Gerar nova chave de API",
        "company": "Empresa",
        "companyRequired": "Selecione uma empresa.",
        "name": "Nome da chave",
        "namePlaceholder": "Ex.: EasyPallet — produção",
        "nameRequired": "Informe um nome.",
        "submit": "Gerar"
      },
      "token": {
        "title": "Chave gerada com sucesso",
        "warning": "Copie a chave agora. Por segurança, ela não será exibida novamente.",
        "copy": "Copiar"
      },
      "revoke": {
        "title": "Revogar chave",
        "message": "Tem certeza que deseja revogar a chave \"{name}\"? Sistemas que a utilizam deixarão de funcionar.",
        "confirm": "Revogar"
      },
      "toast": {
        "revoked": "Chave revogada com sucesso!",
        "revokeError": "Erro ao revogar a chave.",
        "copied": "Chave copiada para a área de transferência!",
        "copyError": "Não foi possível copiar. Copie manualmente.",
        "generateError": "Erro ao gerar a chave.",
        "companiesError": "Erro ao carregar empresas."
      }
    },
    "auth": {
      "signUp": {
        "form": {
          "input": {
            "name": {
              "label": "Nome",
              "placeholder": "Digite seu nome"
            },
            "username": {
              "label": "Usuário",
              "placeholder": "Digite seu nome de usuário"
            },
            "email": {
              "label": "Email",
              "placeholder": "Digite seu email"
            },
            "password": {
              "label": "Senha",
              "placeholder": "Digite sua senha"
            },
            "passwordConfirmation": {
              "label": "Confirme de senha",
              "placeholder": "Digite sua senha novamente"
            }
          },
          "button": {
            "confirm": "Cadastrar"
          }
        }
      },
      "login": {
        "form": {
          "input": {
            "login": {
              "label": "Email ou usuário",
              "placeholder": "Digite seu email ou usuário"
            },
            "password": {
              "label": "Senha",
              "placeholder": "Digite sua senha"
            }
          },
          "button": {
            "confirm": "Entrar"
          }
        }
      }
    },
    "sortType": {
      "form": {
        "addSortType": {
          "title": "Adicionar novo tipo de ordenação",
          "input": {
            "name": {
              "label": "Tipo de ordenação",
              "placeholder": "Digite o nome do tipo de ordenação"
            }
          },
          "button": {
            "confirm": "Adicionar"
          }
        },
        "filter": {
          "input": {
            "perPage": {
              "label": "Tipos de ordenação por página",
              "placeholder": "Número de tipos de ordenação por página"
            },
            "name": {
              "label": "Filtrar por nome",
              "placeholder": "Nome do tipo de ordenação"
            }
          }
        }
      },
      "table": {
        "header": {
          "id": "ID",
          "name": "Nome",
          "actions": "Ações"
        }
      }
    },
    "brand": {
      "form": {
        "addBrand": {
          "title": "Adicionar nova marca",
          "input": {
            "name": {
              "label": "Marca",
              "placeholder": "Digite o nome da marca"
            }
          },
          "button": {
            "confirm": "Adicionar"
          }
        },
        "filter": {
          "input": {
            "perPage": {
              "label": "Marcas por página",
              "placeholder": "Número de marcas por página"
            },
            "name": {
              "label": "Filtrar por nome",
              "placeholder": "Nome da marca"
            }
          }
        }
      },
      "table": {
        "header": {
          "id": "ID",
          "name": "Nome",
          "actions": "Ações"
        }
      }
    },
    "company": {
      "form": {
        "addCompany": {
          "title": "Adicionar nova empresa",
          "input": {
            "name": {
              "label": "Nome da Empresa",
              "placeholder": "Digite o nome da empresa"
            },
            "cnpj": {
              "label": "CNPJ",
              "placeholder": "Digite o CNPJ da empresa"
            },
            "app_version": {
              "label": "Versão do App",
              "placeholder": "Digite a versão do app"
            },
            "data_integration_type": {
              "label": "Tipo de integração de dados",
              "placeholder": "Digite o tipo de integração de dados"
            },
            "brand_name": {
              "label": "Marca",
              "placeholder": "Selecione a marca"
            },
            "brand_id": {
              "label": "ID da Marca",
              "placeholder": "Digite o ID da marca"
            }
          },
          "button": {
            "confirm": "Adicionar"
          }
        },
        "filter": {
          "input": {
            "perPage": {
              "label": "Empresas por página",
              "placeholder": "Número de empresas por página"
            },
            "name": {
              "label": "Filtrar por nome",
              "placeholder": "Nome da empresa"
            }
          }
        }
      },
      "table": {
        "header": {
          "id": "ID",
          "name": "Nome",
          "cnpj": "CNPJ",
          "app_version": "Versão do App",
          "data_integration_type": "Tipo de integração de dados",
          "brand_name": "Nome da Marca",
          "actions": "Ações",
          "pallets": "Pallets",
          "loaded_vehicles": "Veículos carregados",
          "active_users": "Usuários ativos"
        }
      }
    },
    "module": {
      "form": {
        "addModule": {
          "title": "Adicionar novo módulo",
          "input": {
            "name": {
              "label": "Módulo",
              "placeholder": "Digite o nome do módulo"
            }
          },
          "button": {
            "confirm": "Adicionar"
          }
        },
        "filter": {
          "input": {
            "perPage": {
              "label": "Módulos por página",
              "placeholder": "Número de módulos por página"
            },
            "name": {
              "label": "Filtrar por nome",
              "placeholder": "Nome do módulo"
            }
          }
        }
      },
      "table": {
        "header": {
          "id": "ID",
          "name": "Nome",
          "actions": "Ações"
        }
      }
    },
    "clientModule": {
      "title": "Módulos da Empresa",
      "form": {
        "addClientModule": {
          "title": "Adicionar novo módulo à empresa",
          "input": {
            "module_multi_search": {
              "label": "Módulos",
              "placeholder": "Selecione os módulos"
            }
          },
          "button": {
            "confirm": "Adicionar"
          }
        },
        "filter": {
          "input": {
            "perPage": {
              "label": "Módulos por página",
              "placeholder": "Número de módulos por página"
            },
            "name": {
              "label": "Filtrar por nome",
              "placeholder": "Nome do módulo"
            }
          }
        }
      },
      "table": {
        "header": {
          "easyModuleId": "ID",
          "easyModuleName": "Nome",
          "actions": "Ações"
        }
      }
    }
  },
  "language": {
    "brazilian_portuguese": "Português",
    "english": "Inglês",
    "spanish": "Espanhol",
    "simplified_chinese": "Chinês Simplificado",
    "persian": "Persa"
  },
  "menu": {
    "auth": "Autenticação",
    "brands": "Marcas",
    "companies": "Empresas",
    "modules": "Módulos",
    "pilots": "Pilotos",
    "sort_types": "Tipos de Ordenação",
    "palletization_types": "Tipos de Palletização",
    "buttons": "Botões",
    "timelines": "Linhas do Tempo",
    "dashboard": "Painel de Controle",
    "settings": "Configurações",
    "billing": "Cobrança",
    "login": "Entrar",
    "signUp": "Cadastrar-se",
    "preferences": "Preferências",
    "audits": "Auditoria",
    "notifications": "Notificações",
    "payments": "Pagamentos",
    "pricing-plans": "Planos de Preços",
    "login-singup": "Entrar/Cadastrar",
    "404": "Páginas 404",
    "monitoring": "Monitoramento",
    "aiAgentsHome": "Visão geral",
    "aiAgentsFeedbacks": "Feedbacks de paletização",
    "aiAgentsReview": "Para revisar",
    "aiAgentsSettings": "Configurações",
    "faq": "FAQ",
    "implantacoes": "Implantações",
    "service_desk": "Service Desk",
    "visao_geral": "Visão Geral",
    "central_sla": "Central de SLA",
    "tickets": "Tickets",
    "projetos": "Projetos",
    "escala": "Escala de plantão",
    "atendimentos": "Atendimentos",
    "notificacoes_slack": "Notificações no Slack",
    "plantao_config": "Configuração do plantão",
    "coordinates_registry": "Registro de coordenadas",
    "deployment_management": "Gestão de Implantações",
    "project_home": "Visão geral"
  },
  "workspace": {
    "crm": "CRM",
    "serviceDesk": "Service Desk",
    "project": "Project",
    "aiAgents": "AI Agents",
    "switchLabel": "Trocar de área",
    "indicators": "Indicadores",
    "monitoring": "Monitoramento",
    "monitor": "Monitoring"
  },
  "navigationRoutes": {
    "home": "Início"
  },
  "implantacoes": {
    "title": "Gestão de Implantações",
    "subtitle": "Acompanhamento de implantações por CD",
    "filters": {
      "all": "Todos",
      "completed": "Finalizadas",
      "in_progress": "Em andamento",
      "pending": "Pendentes",
      "pilot": "Piloto",
      "search": "Buscar por CD, empresa ou cidade...",
      "status": "Status"
    },
    "zoom": {
      "week": "Semana",
      "month": "Mês",
      "quarter": "Trimestre"
    },
    "tooltip": {
      "company": "Empresa",
      "city": "Cidade",
      "responsible": "Responsável",
      "start": "Início",
      "end": "Fim",
      "status": "Status",
      "no_dates": "Sem datas definidas"
    },
    "status": {
      "completed": "Finalizada",
      "in_progress": "Em andamento",
      "pending": "Pendente",
      "pilot": "Piloto"
    },
    "empty": "Nenhuma implantação encontrada",
    "today": "Hoje",
    "drag_hint": "Arraste as extremidades das barras para ajustar as datas"
  },
  "user": {
    "language": "Mudar Idioma",
    "logout": "Sair",
    "profile": "Meu Perfil",
    "install_app": "Instalar app",
    "settings": "Configurações",
    "billing": "Faturamento",
    "faq": "FAQ",
    "helpAndSupport": "Ajuda & Suporte",
    "projects": "Projetos",
    "account": "Conta",
    "explore": "Explorar"
  },
  "treeView": {
    "basic": "Básico",
    "icons": "I:cones",
    "selectable": "Selecionável",
    "editable": "Editável",
    "advanced": "Advançado"
  },
  "chat": {
    "title": "Gráficos"
  },
  "helpAndSupport": "Ajuda & Suporte",
  "aboutVuesticAdmin": "Sobre Vuestic Admin",
  "search": {
    "placeholder": "Buscar..."
  },
  "users": {
    "id": "id",
    "users": "Usuários",
    "name": "Nome",
    "login": "Login"
  },
  "companies": {
    "id": "id",
    "companies": "Empresas"
  },
  "contacts": {
    "id": "id",
    "contacts": "Contatos"
  },
  "localities": {
    "id": "id",
    "localities": "Centros de Distribuição",
    "registrations": "Mapa",
    "map": "Mapa",
    "indicators": "Indicadores",
    "register": "Registro",
    "easy": "Easy Pelo Mundo"
  },
  "data_integration_types": {
    "id": "id",
    "data_integration_types": "Tipos de Integração de dados"
  },
  "database_names": {
    "id": "id",
    "name": "Nome",
    "database_names": "Nome do Database"
  },
  "monitoring": {
    "monitoring": "Monitoramento"
  },
  "locality_types": {
    "id": "id",
    "locality_types": "Tipos de centros de distribuição",
    "locality_types_CDs": "Tipos de CDs"
  },
  "palletization_types": {
    "id": "id",
    "name": "Nome",
    "palletization_types": "Tipos de centros de palletização"
  },
  "vuestic": {
    "select": "select",
    "pagination": "pagination",
    "toggleDropdown": "toggleDropdown",
    "goToSpecificPage": "goToSpecificPage",
    "optionsFilter": "optionsFilter",
    "search": "search"
  },
  "errors": {
    "messages": {
      "blank": "não pode ficar em branco",
      "invalid": "é inválido",
      "not_a_number": "não é um número"
    },
    "full_messages": {
      "name": {
        "blank": "Nome não pode ficar em branco",
        "invalid": "Nome é inválido"
      },
      "email": {
        "blank": "Email não pode ficar em branco",
        "invalid": "Email é inválido"
      },
      "phone": {
        "blank": "Telefone não pode ficar em branco",
        "not_a_number": "Telefone não é um número"
      },
      "job_title": {
        "blank": "Cargo não pode ficar em branco"
      }
    }
  },
  "pwa": {
    "update_available": "Nova versão do Easy HUB disponível.",
    "update": "Atualizar",
    "later": "Depois",
    "offline": "Sem conexão. As telas abrem, mas os dados não carregam.",
    "offline_ready": "Easy HUB pronto para abrir mesmo com a conexão instável."
  },
  "toast": {
    "type_success": "Sucesso",
    "type_error": "Erro",
    "type_warning": "Atenção",
    "type_info": "Aviso"
  },
  "twoFactor": {
    "login": {
      "title": "Verificação em duas etapas",
      "help": "Digite o código de 6 dígitos do seu app autenticador (Google Authenticator).",
      "codeLabel": "Código de verificação",
      "rememberDevice": "Lembrar deste dispositivo por 30 dias",
      "verify": "Verificar",
      "backupHint": "Perdeu o acesso ao app? Use um dos seus códigos de backup no mesmo campo.",
      "backToLogin": "Voltar ao login",
      "sessionExpired": "Sua sessão expirou. Faça login novamente.",
      "errors": {
        "required": "Informe o código.",
        "invalid": "Código inválido.",
        "invalidRetry": "Código inválido. Tente novamente.",
        "tooMany": "Muitas tentativas. Faça login novamente.",
        "generic": "Não foi possível verificar o código."
      }
    },
    "settings": {
      "label": "Verificação 2FA",
      "enabled": "Ativada",
      "disabled": "Desativada",
      "description": "— protege o login com o Google Authenticator.",
      "enable": "Ativar",
      "disable": "Desativar",
      "activate": {
        "title": "Ativar a verificação em duas etapas",
        "help": "Escaneie o QR code no app Google Authenticator (ou digite a chave manual) e informe o código gerado para confirmar.",
        "qrAlt": "QR code do 2FA",
        "manualKey": "Chave manual:",
        "codeLabel": "Código de 6 dígitos",
        "cancel": "Cancelar",
        "confirm": "Confirmar"
      },
      "backup": {
        "title": "2FA ativada com sucesso",
        "warn": "Guarde estes códigos de backup num lugar seguro. Eles aparecem só agora, cada um serve uma única vez e permitem entrar caso você perca o acesso ao app.",
        "copy": "Copiar",
        "done": "Guardei meus códigos"
      },
      "disableModal": {
        "title": "Desativar a verificação em duas etapas",
        "help": "Confirme sua senha para desativar o 2FA. Sua conta ficará protegida apenas pela senha.",
        "passwordLabel": "Senha",
        "cancel": "Cancelar",
        "confirm": "Desativar"
      },
      "toasts": {
        "activated": "Verificação em duas etapas ativada!",
        "deactivated": "Verificação em duas etapas desativada.",
        "codesCopied": "Códigos copiados.",
        "copyFailed": "Não foi possível copiar. Anote manualmente.",
        "setupFailed": "Não foi possível iniciar a ativação do 2FA."
      },
      "errors": {
        "codeRequired": "Informe o código.",
        "invalidCode": "Código inválido.",
        "passwordRequired": "Informe a senha.",
        "wrongPassword": "Senha incorreta."
      }
    },
    "reminder": {
      "title": "Proteja sua conta com a verificação em duas etapas",
      "body": "Sua conta ainda entra só com senha. Com a verificação em duas etapas, mesmo que alguém descubra sua senha não consegue entrar sem o código do seu celular. Leva menos de um minuto para ativar.",
      "later": "Agora não",
      "activate": "Ativar agora"
    }
  },
  "hub": {
    "brand": "Easy HUB",
    "open": "Abrir",
    "openTool": "Abrir {tool}",
    "tools": {
      "crm": "Easy CRM",
      "service-desk": "Easy Service Desk",
      "project": "Easy Project",
      "ai-agents": "Easy AI Agents",
      "monitoring": "Easy Monitoring"
    },
    "backdrop": {
      "portfolio": "Centros de distribuição",
      "clients": "nenhum cliente | {n} cliente | {n} clientes",
      "brands": "nenhuma marca | {n} marca | {n} marcas",
      "pace": "Ritmo de implantação",
      "daysWithout": "dias sem implantar",
      "byMonth": "Implantações por mês",
      "inYear": "nenhuma no ano | {n} no ano | {n} no ano",
      "growth": "Crescimento por ano",
      "overlaid": "Implantações · 5 anos sobrepostos",
      "byBrand": "Participação por marca",
      "firstLast": "Primeiro e último CD implantado",
      "expiring": "A vencer em 30 dias",
      "inWindow": "nada na janela | {n} na janela | {n} na janela",
      "inPilot": "nenhum em piloto | {n} em piloto | {n} em piloto",
      "nextDate": "próxima data {date}",
      "volumes": "Volumes de operação",
      "pallets": "pallets montados",
      "vehicles": "veículos carregados",
      "users": "usuários ativos"
    },
    "close": "Fechar"
  }
}
